import boletaApi from "./boletaApi";

export const uploadComprobantePago = async (id, body) => {
  try {
    return await boletaApi.post(`/invoices/${id}/comprobante`, body);
  } catch (error) {
    const { response } = error;
    return response;
  }
};
